import cards from "emun.cust/locations/ship-location-list.cards.htm";
import list from "emun.cust/locations/ship-location-list.table.htm";

export default {
  list,
  cards,
};
